module.exports = __webpack_public_path__ + "img/18_41.a2d8c5ef.png";